import React from 'react';

import { accordian } from '../uiFunctions/uiActions';

class AccordianTitle extends React.Component {
    render() {
        const title = this.props.title;
        return(
            <div className="accordian-title" onClick={accordian}>
                <h4>{title}</h4>
            </div>
        )
    }
}
export default AccordianTitle;


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/Accordian.js